module.exports = __webpack_public_path__ + "static/media/flag-checkered.566d653b.svg";